//***** Hooks *****
import { useState } from 'react';
import { useWindowSize } from 'react-use';
import { useTranslation } from 'react-i18next';
// ***** Components *****
import DeleteModal from '@modules/practitioner/profile/public/Education/DeleteModal';
import { Button } from "@fc/devteam-components-library";
// ***** Interfaces, Types and imports *****
import { newDeviceProps } from '@modules/devices/types/types-devices';
import Tooltip from '@material-ui/core/Tooltip';

type itemListProps = {
  dev: newDeviceProps,
  deleteDevice: (id:number) => void,
  setDeviceEdit: (device:newDeviceProps) => void,
  setdDeviceShowSelected?: (device:newDeviceProps) => void
}

const ItemList = ({dev, deleteDevice, setDeviceEdit, setdDeviceShowSelected}:itemListProps) => {

  const { t } = useTranslation(['myDevices'])
  const [openModal, setOpenModal] = useState(false);
  const { width } = useWindowSize();

  const setDeviceToEdit = (device: newDeviceProps) => {
    setDeviceEdit(device);
  }

  const openModalDeleteDevice = () => {
    setOpenModal(true);
  }

  const changeDevideShowSelected = (dev: newDeviceProps) => {
    if(setdDeviceShowSelected){
      setdDeviceShowSelected(dev)
    }
  }


  return (
    <div className="Services__TableBody">
      <div className="Services__TableHeaderItem">
        <em className='fa-solid fa-monitor-waveform'/>
        {dev.identification}
      </div>
      <div className="Services__TableHeaderItem2">{dev.deviceType.code}</div>
      <div className="Services__TableHeaderItem3">{dev.nestedOrganizationStructure.organizationName}</div>
      <div className="Services__TableHeaderItem4">{dev.serialNumber}</div>

      <DeleteModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        onDeleteRow={() => deleteDevice(dev.deviceId)}
      />
      { width <= 1440 ?
        <Button
          buttontype="button"
          buttontext={ `${t('common:see')} ${t('common:more')}`}
          action={() => changeDevideShowSelected(dev)}
        /> 
      :
        <div className="HorizontalFlex__Gap">
          <Tooltip title="Editar">
            <button className="ButtonTertiary" onClick={() => setDeviceToEdit(dev)}>
              <i className="fas fa-pen"/>
            </button>
          </Tooltip>
          <Tooltip title='Eliminar'>
            <button className="ButtonTertiary" onClick={() => openModalDeleteDevice()}>
              <i className="fas fa-trash-alt"/>
            </button>
          </Tooltip>
        </div>
      }
    </div>
  );
};

export default ItemList;
